import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 STEP: Create the Turbonomic Instance`}</h2>
    <a href="https://www.ibm.com/docs/en/tarm/8.7.5?topic=clusters-installing-using-red-hat-openshift-operatorhub" target="_blank">🌏 Documentation for the Task: Create the Turbonomic Instance (Start at Step 5.)</a>
    <p>{`In this section you will deploy a Turbonomic Instance into your Cluster using the Operator installed in the previous section.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Installed Operators`}</inlineCode>{` in the left-side menu`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Turbonomic Platform Operator`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/09_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
    </ol>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li">{`On the Turbonomic Operator page you have all the relevant information for the Operator.
Click `}<inlineCode parentName="p">{`Create Instance`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/10_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You could specify all the parameters in the Form View, but for convenience, switch to the YAML view.
Click on `}<inlineCode parentName="p">{`YAML View`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/11_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Paste the code below into the YAML code field, overwriting the existing content`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-yaml"
          }}>{`apiVersion: charts.helm.k8s.io/v1
kind: Xl
metadata:
  name: xl-release
  namespace: turbonomic
spec:
  webhook:
    enabled: true
  servicenow:
    enabled: true
  websphere:
    enabled: true
  jvm:
    enabled: true
  actionscript:
    enabled: true
  xen:
    enabled: false
  mysql:
    enabled: true
  global:
    customImageNames: false
    repository: icr.io/cpopen/turbonomic
    storageClassName: ocs-storagecluster-ceph-rbd
    storageSelector: false
    tag: 8.8.2
  tomcat:
    enabled: true
  netapp:
    enabled: true
  hyperflex:
    enabled: true
  ucs:
    enabled: true
  udt:
    enabled: true
  mssql:
    enabled: true
  nutanix:
    enabled: true
  weblogic:
    enabled: false
  hyperv:
    enabled: true
  vcenter:
    enabled: true
  hpe3par:
    enabled: true
  oneview:
    enabled: true
  vmax:
    enabled: true
  instana:
    enabled: true
  azure:
    enabled: true
  actionstream-kafka:
    enabled: false
  scaleio:
    enabled: false
  wmi:
    enabled: true
  newrelic:
    enabled: true
  gcp:
    enabled: true
  appdynamics:
    enabled: true
  vmm:
    enabled: true
  jboss:
    enabled: true
  pure:
    enabled: true
  ibmstorage-flashsystem:
    enabled: true
  horizon:
    enabled: true
  appinsights:
    enabled: true
  dynatrace:
    enabled: true
  aws:
    enabled: true
  openshiftingress:
    enabled: true
  snmp:
    enabled: true
  oracle:
    enabled: true
  kubeturbo:
    enabled: true
  prometheus:
    enabled: true
  prometurbo:
    enabled: true
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The result should look like this.
Click on `}<inlineCode parentName="p">{`Create`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/13_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Create`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/14_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
    </ol>
    <h2>{`Follow Installation Progress`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Workloads/Pods`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/16_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Make sure you have selected the `}<inlineCode parentName="p">{`turbonomic`}</inlineCode>{` Project`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/17_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Sort by `}<inlineCode parentName="p">{`Ready`}</inlineCode>{` column `}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/18_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Wait for all Pods to have `}<inlineCode parentName="p">{`1/1`}</inlineCode>{` Status.`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/19_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
    </ol>
    <InlineNotification kind="error" mdxType="InlineNotification"> 
      <p><strong parentName="p">{`Important - Installation takes some time`}</strong></p>
      <p>{`Installation can take 10-30 minutes, just ignore error states like `}<inlineCode parentName="p">{`CrashLoopBackOff`}</inlineCode>{`.`}</p>
      <p>{`If after 30 minutes there are still errors, please check with your instructor.`}</p>
    </InlineNotification>
    <InlineNotification kind="success" mdxType="InlineNotification">
      <p>{`You have successfully finished this Chapter.`}</p>
      <p><strong parentName="p">{`You are now done with the chapter on  Installing Turbonomic`}</strong></p>
      <p>{`Please continue to the next chapter to learn how to Configure Turbonomic.`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      